import { render, staticRenderFns } from "./MerusDataTable.vue?vue&type=template&id=75b0d974&"
import script from "./MerusDataTable.vue?vue&type=script&lang=js&"
export * from "./MerusDataTable.vue?vue&type=script&lang=js&"
import style0 from "./MerusDataTable.vue?vue&type=style&index=0&id=75b0d974&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports